import React from 'react';
import { usePlanningActualState } from '../Context/index';

function SalesPerOptionTable({ years, categoryItem }) {
  const { checkVisible, getFieldValue, getTotalOfField } = usePlanningActualState();
  const salesPerOptions = [
    {
      keyName: 'plannedSPO',
      name: 'Planned Sales Per Option',
    },
    {
      keyName: 'actualSPO',
      name: 'Actual Sales Per Option',
    },
  ];
  return (years ?? []).map((currentYear, yearIndex) => {
    return (
      <table key={yearIndex} className="table custom-table layout-fixed  font-13 mr-3">
        <thead>
          <tr>
            {salesPerOptions.map((salesItem, i) => {
              const isVisible = checkVisible(salesItem.keyName);
              return (
                isVisible && (
                  <th key={i} className="w-200px">
                    <span>
                      {currentYear}&nbsp;
                      {salesItem.name}
                    </span>
                  </th>
                )
              );
            })}
          </tr>
        </thead>
        <tbody>
          {categoryItem?.subcategory &&
            categoryItem.subcategory.map((cat2Ele, iCat) => {
              return (
                <tr key={iCat}>
                  {salesPerOptions.map((salesItem, i) => {
                    const isVisible = checkVisible(salesItem.keyName);
                    return (
                      isVisible && (
                        <td key={i}>{getFieldValue(salesItem.keyName, yearIndex, currentYear, cat2Ele.subcategoryId._id, categoryItem?.categoryId?._id)}</td>
                      )
                    );
                  })}
                </tr>
              );
            })}
        </tbody>
        <tfoot>
          <tr>
            {salesPerOptions.map((item, i) => {
              const isVisible = checkVisible(item.keyName);
              return (
                isVisible && (
                  <td key={i}>
                    <b>{getTotalOfField(item.keyName, yearIndex, currentYear, categoryItem?.categoryId?._id)}</b>
                  </td>
                )
              );
            })}
          </tr>
        </tfoot>
      </table>
    );
  });
}
export default SalesPerOptionTable;
